import { createRootRoute, Outlet } from '@tanstack/react-router';
import { useAuthCheck } from '~/hooks/auth/useAuthCheck';

function RootComponent() {
  useAuthCheck();

  return <Outlet />;
}

export const Route = createRootRoute({
  component: RootComponent,
});
